import { QuickTLClient } from '@quicktl/api-client';

export const api = new QuickTLClient({
  baseUrl: import.meta.env.VITE_API_URL,
});

export function setToken(token: string) {
  api.setToken(token);
  localStorage.setItem('quicktl_token', token);
}

export function clearToken() {
  localStorage.removeItem('quicktl_token');
}

export function loadToken(): string | null {
  return localStorage.getItem('quicktl_token');
}

// Restore token from localStorage on load
const stored = loadToken();
if (stored) {
  api.setToken(stored);
}
